import React, { useState, useEffect } from "react";
import axios from "axios";
import UserComponent from "./UserComponent";
import styles from "./AllUsers.module.css"
import { FormControl, InputLabel, Select, MenuItem, Grid, TextField } from "@mui/material"
import { selectInput, inputLabel, TextInputStyle } from "./MuiStyles/Styles";
import { API_URL } from '../settings';
import { useAuth } from "../Hooks/useAuth";
import PostUsers from "./Components/PostUsers";

const AllUsers = () => {
    const [data, setData] = useState();
    const [ ranges, setRanges ] = useState()
    const [ chosenRange, setChosenRange ] = useState("")
    const [ queryString, setQueryString ] = useState("")
    const [ selectedUsers, setSelectedUsers ] = useState([])
    const { user, logout } = useAuth()
    // Effect to fetch all Named Ranges Sheets
    useEffect(() => { axios.get(`${API_URL}/sheets/sheet-ranges`, { headers: { token: user.data.token}}).then(res => setRanges(res.data.namedRanges)) }, [])

    // Function to fetch all Users Data
    const getRanges = () => axios.get(`${API_URL}/users/main-data/${chosenRange}`, { headers: { token: user.data.token}}).then(res => setData(res.data)).catch((error) => console.log(error))

    // Effect that triggers filter if queryString state string has content
    useEffect(() => { 
        if (data && queryString.length > 0) {
            setData(data.filter(user => user.data.FirstName.toLowerCase().includes(queryString.toLowerCase())))  
        } 
    }, [queryString])

    // Effect to reset users data when search input is empty after query
    useEffect(() => { 
        if (data && queryString.length === 0) {
            getRanges() 
        } 
    }, [queryString])

    // Effect that triggers API call when a new range is chosen
    useEffect(() => {
        chosenRange && getRanges()
    }, [chosenRange]) 

    // Function that sets new chosen range and resets query string state content 
    const onHandleChosenRange = range => {
        setChosenRange(range)
        setQueryString("")
        setSelectedUsers([])
    }
    // Logout function handler
    const handleLogout = () => {
        logout()
        setSelectedUsers([])
    }
    // Function that manages selected users state
    const handleSelectedUsers = (boolean, email, html) => boolean === true ? setSelectedUsers([...selectedUsers, { email, html }]) : setSelectedUsers(selectedUsers.filter(userEmail => userEmail.email !== email))
    return (
        <div className={styles.mainContainer}>  
            <Grid container spacing={2}>
                <Grid item xl={4} sm={4} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel sx={inputLabel}>Teams</InputLabel>
                        <Select value={chosenRange} label="Teams" onChange={e => onHandleChosenRange(e.target.value)} sx={selectInput}>
                            <MenuItem value={chosenRange} >Select a Team</MenuItem>
                            { ranges && ranges.map(range => (<MenuItem key={range.properties.sheetId} value={range.properties.title}>{ range.properties.title }</MenuItem>)) }
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xl={4}>
                    { data && <TextField value={queryString} onChange={(e) => setQueryString(e.target.value)} label="Filter Users by Name" sx={TextInputStyle} fullWidth /> }
                </Grid>
                <Grid item xl={4}>
                    <PostUsers selectedUsers={selectedUsers} />
                </Grid>
            </Grid>

            <button title="Log Out" onClick={() => handleLogout()} className={styles.logoutButton}></button>
            { chosenRange && <button title="Scroll to Top" onClick={() => window.scrollTo({top: 0, behavior:"smooth"})} className={styles.toTopButton}></button> }
            { chosenRange && <button title="Refresh Page" onClick={() => getRanges()} className={styles.refreshButton}></button> } 

            { data ? data.map(user => ( <UserComponent user={user} key={user.data.userId} chosenRange={chosenRange} handleSelectedUsers={handleSelectedUsers} /> )) : 
                <h1 style={{color:"#6D9E93", fontWeight:"600"}}>Choose a team to display data</h1> 
            }
        </ div>
    ) 
};
export default AllUsers;
